import type {Intent} from '@sail/engine';
import {css, tokens} from '@sail/ui';

const totalSizeStyles: Intent = css({
  font: 'label.small',
  color: 'subdued',
  whiteSpace: 'nowrap',
});

const progressBarContainerStyles: Intent = css({
  height: 'space.75',
  borderRadius: 'small',
  backgroundColor: `${tokens.color.neutral[100]}`,
  width: 'fill',
});

const progressBarStyles: Intent = css({
  backgroundColor: 'feedback.info.emphasized',
  height: 'inherit',
  borderRadius: 'inherit',
  transition: 'width 1s',
});

const fileContainerRowStyles: Intent = css({
  stack: 'x',
  alignY: 'center',
  gap: 'space.150',
});
const fileContainerColumnStyles: Intent = css({
  width: 'fill',
  stack: 'y',
  distribute: 'space-between',
  gap: 'space.125',
  minWidth: 'space.0',
});
const fileNameContainerStyles: Intent = css({
  stack: 'x',
  alignY: 'center',
  gap: 'large',
  distribute: 'space-between',
  width: 'fill',
  minWidth: 'space.0',
});
const fileNameStyles: Intent = css({
  width: 'fill',
  color: 'text',
  font: 'body.small',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  marginRight: 'auto',
});
const fileNameStylesUnprocessed: Intent = css({
  textOverflow: 'ellipsis',
});
const filePreviewStyles: Intent = css({
  boxShadow: `inset 0 0 0 1px ${tokens.color.neutral[50]}`,
  color: 'subdued',
  borderRadius: 'xsmall',
  stack: 'y',
  alignY: 'center',
  alignX: 'center',
  width: '54px',
  height: '54px',
  minWidth: '54px',
  minHeight: '54px',
});
const filePreviewStylesUnprocessed: Intent = css({
  objectFit: 'cover',
});
const dividerStyles: Intent = css({marginY: 'medium'});

export const styles = {
  dividerStyles,
  fileContainerColumnStyles,
  fileContainerRowStyles,
  fileNameContainerStyles,
  fileNameStyles,
  fileNameStylesUnprocessed,
  filePreviewStyles,
  filePreviewStylesUnprocessed,
  progressBarStyles,
  progressBarContainerStyles,
  totalSizeStyles,
};
